<template>
    <div class="tips" ref="appOpen" v-show="showTips" @click="toLink">
        <div class="topTips clearfix topTipsDown">
        <span class="homeIcon" style="background-image:url('https://img2.hebnews.cn/img/home.53fe0d7.png');background-size:100%;"></span> 
        <i class="rightLine"></i> <span class="slogon">纵览新闻</span> <span class="openApp" id="appOpenCodeUrl">下载</span></div>
    </div>
</template>

<script>

import jump2zonglan from '@/utils/jump2app-zonglan.js'

export default {
  name:'tips',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      showTips:true,
      accountId: '',
      uniqueId: '',
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted() {
    this.checkTips()
    if (process.env.NODE_ENV === 'development') { // 开发环境
        // 指定用户登录测试
        let accountId = '63195bfa72385b281e405979';
        let uniqueId = '6aa4142b1455c02342a9d012';
        this.accountId = accountId;
        this.uniqueId = uniqueId;
        this.$store.commit("SET_ACCOUNTID",accountId);
        this.$store.commit("SET_UNIQUEID",uniqueId);    
        this.logged();
    } else if (process.env.NODE_ENV === 'production') { // 生产环境        
        this.cpLoad(true)  //日报客户端js-sdk加载并初始化
    }
  },
  methods: {
    cpLoad(runAll) {
      let _this = this; 
      let cpMain = function() {
        
          let is_login = false;
          CP.getDeviceInfo({
              completed: function(data){
                  // data > {device_no:'',system:'',system_version:'',device_type:'',timestamp: '',signature：'', app: '', version: '', networkType: '', statusBarHeight: ''}
                  CP.tools.writelog('get_device_info', data);                   
                  console.log('zonglan_version',data.version);
              },
              cpIncompatible: function () {
                  CP.tools.writelog('CP.getDeviceInfo', '此环境不支持此方法');
              }
          });
          //自身的业务代码，以下为调用样例
          CP.isLogin({  //判断是否登录的接口，
            completed: function(data){
            CP.tools.writelog('get_is_login', data);			
            if(data.is_login==1) {
              is_login=true;					
              //获取unique_id
              CP.getUniqueId({
                completed: function(data){
                  console.log('data.unique_id',data.unique_id);
                  _this.$store.commit("SET_UNIQUEID",data.unique_id);
                  _this.uniqueId = data.unique_id;
                  //获取account_id
                  CP.getAccountId({
                    completed: function(data){
                      console.log('data.account_id',data.account_id);
                      _this.$store.commit("SET_ACCOUNTID",data.account_id);
                      _this.accountId = data.account_id;
                      _this.logged();
                    },
                    cpIncompatible: function () {
                      CP.tools.writelog('CP.getAccountId', '此环境不支持此方法');
                    }
                  });
                },
                cpIncompatible: function () {
                  CP.tools.writelog('CP.getUniqueId', '此环境不支持此方法');
                }
              });
            } else {
              //调用用户登录窗口
              CP.showLogin({
                completed: function(data){
                  if(data.is_login==1) {
                    console.log(data.account_id);
                    _this.$store.commit("SET_UNIQUEID",data.unique_id);
                    _this.$store.commit("SET_ACCOUNTID",data.account_id);
                    _this.uniqueId = data.unique_id;
                    _this.accountId = data.account_id;
                    _this.logged();
                  }
                  CP.tools.writelog('show_login', data);
                },
                cpIncompatible: function () {
                  CP.tools.writelog('CP.showLogin', '此环境不支持此方法');
                }
              });
            }   
          },
          cpIncompatible: function () {
            CP.tools.writelog('CP.isLogin', '此环境不支持此方法');
          }
          });
      }

      if(runAll) {
        let zjrbCp = document.createElement('script');
        zjrbCp.async = "async";
        zjrbCp.src = 'https://cdn-cp.tmuyun.com/jssdk/v1/zjrb-cp.v1.min.js';
        zjrbCp.charset = "UTF-8";
        document.body.appendChild(zjrbCp);     
        
        localStorage.setItem('hbrb_account_id', '');
        localStorage.setItem('hbrb_unique_id', '');

        zjrbCp.onload = function(){
          if(CP && typeof CP.ready === 'function'){
              console.log("CP准备就绪");
              CP.ready({
                debug:false,  //可选，是否是开启调试模式, 默认false
                es6Require: false, //可选，是否需要加载es6库，默认false
                ready:function(client_info){
                  //jssdk加载完成调用此方法
                  console.log('业务逻辑初始化开始');
                  cpMain();// 业务逻辑初始化的main函数
                },
                error: function (error) {
                  console.log('出现错误',error);
                }
              });
          }
        }
      } else {
        cpMain();// 业务逻辑初始化的main函数
      }       
    },
    logged() {
      if (this.$parent && typeof this.$parent.loginInit === 'function') {
        this.$parent.loginInit();
      } else {
        console.log('父组件不存在 loginInit 方法');
      }
    },
    checkTips() {
        if (/(hbxw)/i.test(navigator.userAgent)) {
            this.showTips = false;
        } else {
            this.showTips = true;
        }
    },
    toLink() {
      jump2zonglan.toMLink(window.location.href)
    },
    clickOpen(){
      console.log('appOpen');
      this.$refs.appOpen.click();
    },
    closeTips() {
        this.showTips = false;
    }
  },
}
</script>
<style scoped>
/* 纵览客户端顶部下载提示样式 */
.tips{ background:#fff;z-index:100}
.tips,.tips .bankBlock,.tips .topTips{width:750px;height:100px;max-width:750px}
.tips .topTips{max-width:750px;background:#fff;z-index:100;border-top:2px solid #f5f5f5;border-bottom:.2px solid #f5f5f5}
.tips .topTips .homeIcon{float:left;display:inline-block;width:80px;height:80px;background-position:50%;background-repeat:no-repeat;margin:10px 25px}
.tips .topTips .rightLine{display:inline-block;height:50px; margin: 25px 1px; background:#f5f5f5;float:left}
.tips .topTips .slogon{float:left;color:#9e9e9e;font-size:28px; height: 40px; line-height: 40px; display: inline-block; margin: 30px 0px;}
.tips .topTips .openApp{float:right;margin: 25px;display:flex;width: 120px; height: 50px;border-radius: 30px;background:#e51c23;color:#fff;font-size: 28px;text-align:center;justify-content:center;align-items:center;}
.tips .topTipsUp{top:-138px;}
.tips .topTipsDown{top:0}
</style>
